/**
 * 安聆 SafeListen - 音频分析工具
 * 基于 Web Audio API，计算声音能量并归一化到 0~1，适配移动端低性能消耗
 */

/**
 * 从 AudioBuffer 计算当前帧声音能量平均值（归一化 0~1）
 * @param {AudioBuffer} buffer
 * @returns {number} 0~1
 */
export function analyzeAudioData(buffer) {
  const data = buffer.getChannelData(0);
  let sum = 0;
  const len = data.length;
  const step = Math.max(1, Math.floor(len / 256));
  for (let i = 0; i < len; i += step) {
    sum += Math.abs(data[i]);
  }
  const count = Math.ceil(len / step);
  const avg = count > 0 ? sum / count : 0;
  return Math.min(1, avg * 2);
}

/**
 * 播放正弦波警报声
 * @param {AudioContext} ctx
 * @param {number} durationMs
 * @param {number} freq
 */
export function playAlarmTone(ctx, durationMs = 500, freq = 800) {
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = freq;
    osc.type = 'sine';
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + durationMs / 1000);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + durationMs / 1000);
  } catch (_) {}
}

/**
 * 触发设备震动（支持 vibrate API）
 * @param {number|number[]} pattern 如 [200, 100, 200]
 */
export function triggerVibrate(pattern = [200, 100, 200]) {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
}
